<template>
  <svg
    class="crv-my-crv crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M17.505,17.495 C19.2803906,17.495 20.7192857,16.0680957 20.7192857,14.3075 C20.7192857,12.5469043 19.2803906,11.12 17.505,11.12 C15.7296094,11.12 14.2907143,12.5469043 14.2907143,14.3075 C14.2907143,16.0680957 15.7296094,17.495 17.505,17.495 Z M19.755,18.291875 L19.3356362,18.291875 C18.7781585,18.5458789 18.1579018,18.6903125 17.505,18.6903125 C16.8520982,18.6903125 16.2343527,18.5458789 15.6743638,18.291875 L15.255,18.291875 C13.3917187,18.291875 11.88,19.7909961 11.88,21.63875 L11.88,22.6746875 C11.88,23.3345996 12.4198996,23.87 13.0853571,23.87 L21.9246429,23.87 C22.5901004,23.87 23.13,23.3345996 23.13,22.6746875 L23.13,21.63875 C23.13,19.7909961 21.6182812,18.291875 19.755,18.291875 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvMyCrv',
}
</script>